/**
 * Habilidades do usuário no papel da empresa ativa (vêm do /me).
 *
 * hasAbility aceita um slug ou uma lista; com lista basta ter um deles,
 * que é o que um grupo do menu precisa (aparece se algum filho aparece).
 * Item sem habilidade definida é sempre liberado.
 */
export function storedAbilities() {
  try {
    return JSON.parse(localStorage.getItem('abilities')) || []
  } catch (e) {
    return []
  }
}

export function isStoredSuperAdmin() {
  return localStorage.getItem('is_super_admin') === 'true'
}

export function hasAbility(slug, abilities = storedAbilities()) {
  const slugs = Array.isArray(slug) ? slug : [slug]

  return slugs.some(item => !item || abilities.includes(item))
}

export default {
  install(Vue) {
    Vue.prototype.$hasAbility = function (slug) {
      return hasAbility(slug, this.$store.state.user.abilities)
    }
  },
}
